"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedVariation = void 0;
class FeedVariation {
    constructor({ id, label, price, sales_price, quantity } = {
        id: '',
        label: '',
        price: 0,
        sales_price: 0,
        quantity: null
    }) {
        this.id = id;
        this.label = label;
        this.price = price;
        this.sales_price = sales_price;
        this.quantity = quantity;
    }
}
exports.FeedVariation = FeedVariation;
//# sourceMappingURL=feedvariation.js.map